import { ButtonComponentConfig, IconType } from '@rappider/rappider-components/utils';
import { POP_CONFIRM_DELETE_ACTION } from 'libs/shared/src/lib/configs/pop-confirm-button/pop-confirm-button-config';

export const containerTitleBarButtons: ButtonComponentConfig[] = [
  /*
    {
        key: 'add-container-before',
        tooltipText: 'Add a container before this component',
        icon: {
            name: 'fa-kit fa-regular-square-dashed-circle-arrow-right fa-flip-horizontal',
            type: IconType.FontAwesome,
            color: 'var(--text-and-icon-color)'
        }
    },
    {
        key: 'add-container-after',
        tooltipText: 'Add a container after this component',
        icon: {
            name: 'fa-kit fa-regular-square-dashed-circle-arrow-right',
            type: IconType.FontAwesome,
            color: 'var(--text-and-icon-color)'
        }
    },
    {
        key: 'add-component-before',
        tooltipText: 'Add a component before this component',
        icon: {
            name: 'fa-kit fa-sharp-regular-puzzle-piece-simple-circle-arrow-right fa-flip-horizontal',
            type: IconType.FontAwesome,
            color: 'var(--text-and-icon-color)'
        }
    },
    {
        key: 'add-component-after',
        tooltipText: 'Add a component after this component',
        icon: {
            name: 'fa-kit fa-sharp-regular-puzzle-piece-simple-circle-arrow-right',
            type: IconType.FontAwesome,
            color: 'var(--text-and-icon-color)'
        }
    },
    */
  {
    key: 'container-add-comment',
    tooltipText: 'Add a comment for this component',
    icon: {
      name: 'fa-kit fa-regular-comment-circle-plus',
      type: IconType.FontAwesome,
      color: 'var(--text-and-icon-color)'
    }
  },
  {
    key: 'clear-page',
    tooltipText: 'Clear Page',
    icon: {
      name: 'fa-regular fa-broom-wide',
      type: IconType.FontAwesome,
      color: 'var(--text-color)'
    },
    emitWithoutPopconfirm: POP_CONFIRM_DELETE_ACTION.emitWithoutPopconfirm,
    behavior: POP_CONFIRM_DELETE_ACTION.behavior,
    popconfirmTitle: 'Proceeding with this action will permanently delete all content on this page. This action cannot be undone. Are you sure you want to continue?',
    popconfirmOkDanger: POP_CONFIRM_DELETE_ACTION.popconfirmOkDanger,
  },
  {
    key: 'delete-container',
    tooltipText: 'Delete Container',
    popconfirmTitle: 'CONTENT_EDITOR_MODULE.DELETE_PAGE_CONTAINER_COMPONENT.DELETE_CONTAINER_CONFIRMATION',
    emitWithoutPopconfirm: POP_CONFIRM_DELETE_ACTION.emitWithoutPopconfirm,
    behavior: POP_CONFIRM_DELETE_ACTION.behavior,
    popconfirmOkText: POP_CONFIRM_DELETE_ACTION.popconfirmOkText,
    popconfirmOkDanger: POP_CONFIRM_DELETE_ACTION.popconfirmOkDanger,
    icon: {
      name: 'far fa-trash',
      type: IconType.FontAwesome
    }
  },
  /*
  {
      key: 'container-visibility',
      tooltipText: 'Click to see container visibility settings',
      icon: {
          name: 'fa-regular fa-eye',
          type: IconType.FontAwesome,
          color: 'var(--text-and-icon-color)'
      }
  },
  {
      key: 'see-container-comments',
      tooltipText: 'Click to see comments',
      icon: {
          name: 'fa-regular fa-comment',
          type: IconType.FontAwesome,
          color: 'var(--text-and-icon-color)'
      }
  }
      */
];

export function containerTitleBarButtonVisibilityFunction(button: ButtonComponentConfig, contentTreeItem, hasClipboardData: boolean) {
  if (button.key === 'delete-container' && contentTreeItem.isMainContainer) {
    return false;
  } else if (button.key === 'clear-page' && !contentTreeItem.isMainContainer) {
    return false;
  } else {
    return true;
  }
}
